import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './ui/design-system.css'
import './index.css'
import './styles/conversational-apply.css'
import App from './App.jsx'
import { initializeInterceptor } from './utils/apiInterceptor'
import { preloadProgramCatalog } from './utils/programRouterMatch'

// Initialize API interceptor for authentication
initializeInterceptor();

async function boot() {
  await preloadProgramCatalog().catch(() => {})
  createRoot(document.getElementById('root')).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

boot()
